 
import React, { useEffect } from "react";

import "../pages/DashboardPages/NeedPages/searchResults.css"
const PaginationFile = ({
  totalRecords,
  usersPerPage,
  currentRecordsPerPage,
  setCurrentRecordsPerPage,
}) => {
  
  const totalPages = Math.ceil(totalRecords / usersPerPage);

  // Add useEffect to handle scroll after page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentRecordsPerPage]);

  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentRecordsPerPage <= 2) {
      return [1, 2, 3, "..."];
    } else if (currentRecordsPerPage >= totalPages - 1) {
      return ["...", totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [
        "...",
        currentRecordsPerPage - 1,
        currentRecordsPerPage,
        currentRecordsPerPage + 1,
        "...",
      ];
    }
  };

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && newPage !== currentRecordsPerPage) {
      setCurrentRecordsPerPage(newPage);
    }
  };

  return (
    <div className="search-pagination-wrapper my-3">
      <button
        className="search-pagination-btn search-first-btn"
        disabled={currentRecordsPerPage === 1}
        onClick={() => changePage(1)}
      >
        «
      </button>
      {/* <button
        className="search-pagination-btn search-prev-btn"
        disabled={currentRecordsPerPage === 1}
        onClick={() => changePage(currentRecordsPerPage - 1)}
      >
        Previous
      </button> */}
      <div className="search-page-numbers">
        {getPageNumbers().map((pageNum, index) => (
          <button
            key={index}
            className={`search-page-number ${
              currentRecordsPerPage === pageNum ? "search-page-active" : ""
            } ${pageNum === "..." ? "search-ellipsis" : ""}`}
            onClick={() => typeof pageNum === "number" && changePage(pageNum)}
            disabled={pageNum === "..."}
          >
            {pageNum}
          </button>
        ))}
      </div>
      {/* <button
        className="search-pagination-btn search-next-btn"
        disabled={currentRecordsPerPage === totalPages}
        onClick={() => changePage(currentRecordsPerPage + 1)}
      >
        Next
      </button> */}
      <button
        className="search-pagination-btn search-last-btn"
        disabled={currentRecordsPerPage === totalPages}
        onClick={() => changePage(totalPages)}
      >
        »
      </button>
    </div>
  );
};

export default PaginationFile;
 